import React from 'react'

const PlayButton = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.99999 18.3333C14.6024 18.3333 18.3333 14.6023 18.3333 9.99996C18.3333 5.39759 14.6024 1.66663 9.99999 1.66663C5.39762 1.66663 1.66666 5.39759 1.66666 9.99996C1.66666 14.6023 5.39762 18.3333 9.99999 18.3333Z" stroke="#2F3237" strokeWidth="1.5"/>
    <path d="M13.2877 10.329C13.1405 10.8513 12.4444 11.2204 11.0524 11.9585C9.70667 12.672 9.03383 13.0289 8.49158 12.8855C8.26742 12.8261 8.06317 12.7135 7.89843 12.5585C7.5 12.1832 7.5 11.4555 7.5 10C7.5 8.54462 7.5 7.81686 7.89843 7.44166C8.06317 7.28655 8.26742 7.17394 8.49158 7.11465C9.03383 6.97124 9.70667 7.32801 11.0524 8.04156C12.4444 8.77971 13.1405 9.14879 13.2877 9.67104C13.3485 9.88662 13.3485 10.1135 13.2877 10.329Z" stroke="#2F3237" strokeWidth="1.5" strokeLinejoin="round"/>
    </svg>
    
  )
}

export default PlayButton
